import React, { Component } from "react";
import {
  ImgAsesoriasContables,
  ImgAsesoriasContables2,
} from "../../images/servicios";
import { ModernServicePage } from "../modern";

export class Asesoria extends Component {
  render() {
    const serviceData = {
      title: "Asesorías Contables",
      subtitle:
        "Somos especialistas en Asesoría Tributaria, Laboral, Contable y Legal con más de 20 años de experiencia",
      description:
        "Damos nuestros servicios a una amplia gama de empresas de diversos mercados y sectores económicos nacionales como internacionales.",
      whatsappMessage: "Hola, necesito información sobre asesorías contables",
      features: [
        {
          emoji: "📊",
          title: "Optimización Tributaria",
          description:
            "En Chile, el mantener una empresa ya sea grande o pequeña puede ser muy alto debido a los altos impuestos que se deben pagar mensual y anualmente al fisco. El IVA, el Impuesto a la Renta Anual, las distintas retenciones, y otros impuestos específicos pueden consumir en promedio hasta el 35% anual de las utilidades de las empresas.",
        },
        {
          emoji: "💼",
          title: "Experiencia Comprobada",
          description:
            "Somos una empresa de contabilidad dinámica, con los recursos y elementos necesarios para la óptima ejecución de nuestras actividades y más de 20 años de experiencia en el mercado de la consultoría y asesoría contable, tributarias y laborales en Chile.",
        },
        {
          emoji: "👥",
          title: "Equipo Profesional",
          description:
            "Contamos con contadores profesionales interdisciplinarios y altamente capacitados, que entregan soluciones personalizadas e innovadoras.",
        },
        {
          emoji: "📈",
          title: "Análisis Financiero",
          description:
            "Realizamos análisis Económicos-Financieros, Auditorías y asesoramientos específicos de gran complejidad que requieran un alto grado de análisis.",
        },
        {
          emoji: "🎯",
          title: "Soluciones Personalizadas",
          description:
            "Cada empresa es única, por eso desarrollamos estrategias contables y tributarias específicas para tu negocio, optimizando recursos y maximizando beneficios.",
        },
        {
          emoji: "⚡",
          title: "Respuesta Rápida",
          description:
            "Entendemos que el tiempo es dinero. Nuestro equipo está capacitado para brindar respuestas ágiles y eficientes a todas tus consultas contables.",
        },
      ],
      images: [
        {
          src: ImgAsesoriasContables,
          alt: "Asesorías Contables Profesionales",
        },
        {
          src: ImgAsesoriasContables2,
          alt: "Servicios Contables Especializados",
        },
      ],
      benefits: [
        "Más de 20 años de experiencia en el mercado",
        "Equipo de contadores certificados",
        "Atención personalizada para cada cliente",
        "Optimización tributaria garantizada",
        "Cumplimiento normativo al 100%",
        "Tecnología de vanguardia",
        "Soporte continuo durante todo el año",
      ],
      navigationItems: [
        { id: "feature-0", label: "Optimización" },
        { id: "feature-1", label: "Experiencia" },
        { id: "feature-2", label: "Equipo" },
        { id: "feature-3", label: "Análisis" },
      ],
    };

    return <ModernServicePage {...serviceData} />;
  }
}

export default Asesoria;
